/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  SearchAIAnswer,
  SearchAIAnswerStream,
  SearchAIQuery,
  SearchAIRecommendedQuestions,
  SearchAIRecommendedQuestionStream,
} from "./data-contracts";

/**
 * @description Ask a question to an AI across spaces that is accessible by the currently authenticated target.
 * @tags organization-ask
 * @name AskInOrganization
 * @summary Ask a question in an organization
 * @request POST:/orgs/{organizationId}/ask
 * @secure
 */

// @ts-ignore
export const askInOrganization: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {
    /** Output format for the content. */
    format?: "document" | "markdown";
    /** Return query details in the result */
    details?: boolean;
  };
  RequestBody: SearchAIQuery;
  RequestHeaders: {};
  ResponseBody: {
    /** Answer from AI for a question asked on a content. */
    answer?: SearchAIAnswer;
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/ask",
  method: "post",
  streaming: false,
  tags: ["organization-ask"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organization-ask
 * @name GetRecommendedQuestionsInOrganization
 * @summary List recommended questions to ask in an organization
 * @request GET:/orgs/{organizationId}/ask/questions
 * @secure
 */

// @ts-ignore
export const getRecommendedQuestionsInOrganization: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SearchAIRecommendedQuestions;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/ask/questions",
  method: "get",
  streaming: false,
  tags: ["organization-ask"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organization-ask
 * @name StreamRecommendedQuestionsInOrganization
 * @summary List recommended questions to ask in an organization (streamed)
 * @request GET:/orgs/{organizationId}/ask/questions/stream
 * @secure
 */

// @ts-ignore
export const streamRecommendedQuestionsInOrganization: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: true;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SearchAIRecommendedQuestionStream;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/ask/questions/stream",
  method: "get",
  streaming: true,
  tags: ["organization-ask"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Ask a question to an AI across spaces that is accessible by the currently authenticated target and stream the answer as a Server-Sent Events URL.
 * @tags organization-ask
 * @name StreamAskInOrganization
 * @summary Ask a question in an organization (streamed)
 * @request GET:/orgs/{organizationId}/ask/stream
 * @secure
 */

// @ts-ignore
export const streamAskInOrganization: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: true;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {
    query: string;
    /** Output format for the content. */
    format?: "document" | "markdown";
    /** Return query details in the result */
    details?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SearchAIAnswerStream;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/ask/stream",
  method: "get",
  streaming: true,
  tags: ["organization-ask"],
  criticalityLevel: "low",
  deprecated: false,
};
